import React from "react";
import { MessageSquarePlus, MessageSquare, ChevronUp } from "lucide-react";

const ReviewAction = ({ review, expanded, onClick, controls }) => {
  const Icon = expanded ? ChevronUp : review ? MessageSquare : MessageSquarePlus;
  return <button type="button" className="review-button review-button--context" onClick={onClick}
    aria-expanded={controls ? expanded : undefined} aria-controls={controls}>
    <Icon size={18} aria-hidden="true" />
    {expanded ? "بستن نظر" : review ? "نظر شما" : "ثبت نظر"}
  </button>;
};

export default ReviewAction;
